import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
require('./assets/css/milligram.css')

Vue.use(VeeValidate)

Vue.config.productionTip = false

export default class OIDonate {
  constructor (settings) {
    this.el = settings.el
    this.settings = settings
    this.settings.form = this.settings.form || 'light'
  }

  mount () {
    const settings = this.settings

    this.app = new Vue({
      router,
      el: this.el,
      store: store.createStore(),
      render: h => h(App, {
        props: { settings },
        ref: 'oi-donate'
      }),
      mounted: function () {
        const queryString = this.$route.query
        this.$store.dispatch('parseQueryString', queryString)
      }
    })
    return this
  }

  modify (props) {
    const oiDonate = this.app.$refs['oi-donate']
    oiDonate.modifySettings(props)
    return this
  }
}
